import classNames from 'classnames';
import LoadingButton from 'components/fantaclasse/LoadingButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { supabase } from 'supabase/client';

const PasswordResetForm = ({ hasLabel }) => {
  // State
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [validated, setValidated] = useState(false);

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // Handler
  const handleSubmit = async e => {
    const form = e.currentTarget; // get the form element
    e.preventDefault(); // prevent the default form submission
    if (form.checkValidity() === false) {
      // if the form has errors
      e.stopPropagation(); // stop the event propagation
    } else {
      // if the form is valid
      try {
        setIsLoading(true);
        const { error } = await supabase.auth.updateUser({
          password: formData.password
        });
        if (error) throw error;

        toast.success('La tua password è stata reimpostata con successo!');
        navigate('/');
      } catch (error) {
        toast.error(
          <p className="mb-0">Errore nell'invio del link: {error.message}</p>
        );
      } finally {
        setIsLoading(false);
      }
    }
    setValidated(true); // set the validated state to true (to show feedbacks)
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form
      noValidate
      validated={validated}
      className={classNames('mt-3', { 'text-left': hasLabel })}
      onSubmit={handleSubmit}
    >
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Nuova Password</Form.Label>}
        <Form.Control
          name="password"
          value={formData.password}
          placeholder={!hasLabel ? 'Nuova Password' : ''}
          minLength={6}
          type="password"
          onChange={handleFieldChange}
          required
        />
        <Form.Control.Feedback type="invalid">
          La password deve contenere almeno 6 caratteri.
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Conferma Password</Form.Label>}
        <Form.Control
          name="confirmPassword"
          value={formData.confirmPassword}
          placeholder={!hasLabel ? 'Conferma Password' : ''}
          minLength={6}
          type="password"
          onChange={handleFieldChange}
          required
        />
      </Form.Group>

      <LoadingButton
        className="w-100"
        type="submit"
        disabled={
          !formData.password ||
          !formData.confirmPassword ||
          formData.password !== formData.confirmPassword
        }
        isLoading={isLoading}
        text="Reimposta password"
      />
    </Form>
  );
};

PasswordResetForm.propTypes = {
  hasLabel: PropTypes.bool
};

export default PasswordResetForm;
